// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__mjWPz","rowsWrapper":"style_rowsWrapper__3k7cP","rowWrapper":"style_rowWrapper__XHPQY","text":"style_text___S3M6"};